import React, {useState, useEffect} from "react";
import { useLocation } from "react-router-dom";
import { Typography, Button, Box, CircularProgress } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { toast } from "react-toastify";
import useToast from "../../helpers/useToast";
import { emailVerifiedGreetingApi } from "../../api/authApi/authApi";

const EmailVerifiedGreeting = () => {
    const {search} = useLocation();
    const toastOptions = useToast();
    const [loading, setLoading] = useState(true);
    const [verificationError, setVerificationError] = useState("");
    
    useEffect(() => {
        const verifyEmail = async () => {
          try {
            let otpId = search.split('=')[1];

            if (otpId) {
              const response = await emailVerifiedGreetingApi(otpId);
              // console.log("successfully verify",response.data);
              setLoading(false);
            }
          } catch (error) {
            toast.error(error.response.data.message, toastOptions);
            setVerificationError(error.response.data.message);
            setLoading(false);
          }
        };
    
        verifyEmail();
      }, [search]); 

      if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <CircularProgress color="primary" />
            </Box>
        );
    }

    if (verificationError) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <Typography variant="body1" gutterBottom sx={{ color: "#E14B0F", textAlign: "center" }}>
                    {verificationError}
                </Typography>
            </Box>
        );
    }

    
  return (
    <div>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box sx={{marginTop: "10%", padding: "10px", border: "1px solid #80807F", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px"}}>
            <Typography variant="body1" gutterBottom sx={{ color: "#E14B0F ", fontSize: "20px"}}> 
                Thank you for verifying your email address.
            </Typography>
            <CheckCircleOutlineIcon sx={{ fontSize: 20, verticalAlign: "middle", marginLeft: "45%", width: "50px", height: "50px", color: "green", marginTop: "20px", marginBottom: "20px"}} />
            <Typography variant="body1" gutterBottom sx={{color: "#989887 "}}>
                You can now proceed to login to your account.
            </Typography>
            <Button variant="contained" color="primary" href="/" fullWidth  endIcon={<ArrowForwardIcon />}>
                Go to login
            </Button>
            </Box>  
        </Box>
    </div>
  );
};

export default EmailVerifiedGreeting;
